import { formatDateForApi } from '@/shared/lib';
import type { CreateOnboardingTrainingSessionPayload } from '@/entities/Training';
import type { OnboardingMinistranteRow } from '../model/useOnboardingMinistrantes';

export function buildMinistranteSessionPayload(
  row: OnboardingMinistranteRow
): CreateOnboardingTrainingSessionPayload | null {
  if (row.responsibleMemberId === null || row.responsibleUserPositionId === null || row.trainingDate === null) {
    return null;
  }
  const trainingDate = formatDateForApi(row.trainingDate);
  if (trainingDate === null) return null;

  return {
    responsibleMemberId: row.responsibleMemberId,
    responsibleUserPositionId: row.responsibleUserPositionId,
    trainingDate,
  };
}
